class Gateway {
  normalize = (data) => {
    let props = data.assetInfo.metadata.props;
    const nodeName = data.nodeName;
    return {
      id: data.nodeAddress,
      areaId: props.areaId,
      areaName: props.areaName,
      siteId: props.siteId,
      siteName: props.siteName,
      placedInArea: props.mapPoint
        ? props.areaName
          ? props.areaName
          : 'N/A'
        : '',
      value: props.name ? props.name : nodeName,
      name: data.nodeName,
      macAddress: props.macAddress,
      point: props.mapPoint ? props.mapPoint.split(',').map(Number) : [],
      checked: false,
      zoneId: props.zoneId,
      zoneName: props.zoneName,
      lastProvisioned: props.lastProvisioned,
      unprovisionedTime: props.unprovisionedTime,
    };
  };
}

export default Gateway;
